import React, { useMemo } from 'react';
import { IconButton } from '@material-ui/core';
import { ArrowLeft } from 'react-feather';

type Props = {
  currentStep: number;
  maxSteps: number;
  onClick: () => void;
  onClickAtFirstStep?: () => void;
};

const StepperBackButton = ({
  currentStep,
  maxSteps,
  onClick,
  onClickAtFirstStep,
}: Props): JSX.Element => {
  const hideButton = useMemo(() => {
    return (
      (currentStep <= 0 && !onClickAtFirstStep) || currentStep >= maxSteps - 1
    );
  }, [currentStep, maxSteps, onClickAtFirstStep]);

  return useMemo(() => {
    if (hideButton) {
      return <div data-testid="empty" />;
    }
    return (
      <IconButton
        data-testid="button"
        style={{ width: 'max-content' }}
        onClick={(): void => {
          if (currentStep === 0 && onClickAtFirstStep) {
            onClickAtFirstStep();
          } else {
            onClick();
          }
        }}
      >
        <ArrowLeft />
      </IconButton>
    );
  }, [hideButton, onClick, onClickAtFirstStep, currentStep]);
};

export default StepperBackButton;
